export enum LatePaymentPenaltyRateMentionType {
  Default = 'default',
  Custom = 'custom',
}
